<template>
  <div class="vue-flow__node-default custom-node-padding knowledge-base-node">
    <Handle type="target" :position="Position.Left" />
    <div class="node-type-tag">Knowledge base step</div>
    <div>{{ data.label !== undefined && data.label !== null && data.label !== '' ? data.label : 'Knowledge base step' }}</div>
    <div v-if="summaryText !== ''" class="node-description">
      {{ summaryText }}
    </div>
    <Handle type="source" :position="Position.Right" />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { Handle, Position } from '@vue-flow/core';

const props = defineProps({
  data: {
    type: Object,
    required: true,
  },

});

function trimText(value) {
  if (typeof value === 'string') {
    return value.trim();
  }
  return '';
}

function shortenText(value) {
  const text = trimText(value);
  if (text.length <= 90) {
    return text;
  }
  return `${text.slice(0, 87)}...`;
}

const summaryText = computed(() => {
  if (props.data === null || props.data === undefined) {
    return '';
  }
  const description = shortenText(props.data.stepDescription);
  if (description.length > 0) {
    return description;
  }
  const variables = Array.isArray(props.data.variablesToCollect) === true ? props.data.variablesToCollect.length : 0;
  if (variables > 0) {
    return `Collects ${variables} field${variables === 1 ? '' : 's'}`;
  }
  return '';
});
</script>

<style scoped>
.knowledge-base-node {
  background-color: #F9FAFB;
  border: 1px solid #D1D5DB;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  min-width: 260px;
  max-width: 380px;
}

.node-type-tag {
  background-color: #6B7280;
  color: #FFFFFF;
  font-size: 0.75rem;
  padding: 4px 12px;
  border-radius: 9999px;
  margin-bottom: 10px;
  display: inline-block;
  text-transform: uppercase;
  font-weight: 600;
  border: none;
}

.custom-node-padding {
  padding: 15px 20px;
}

.knowledge-base-node > div:not(.node-type-tag):not(.node-description) {
  font-size: 0.9rem;
  color: #334155;
  text-align: center;
}

.node-description {
  font-size: 0.8rem;
  color: #4B5563;
  margin-top: 8px;
  white-space: pre-wrap;
  background-color: #F3F4F6;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px dashed #D1D5DB;
  text-align: left;
  min-width: 220px;
}
</style> 